import { Component, Input } from '@angular/core';
import { EmptyStateVisualSource } from './models/empty-state-visual-sources';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EmptyStateVisualComponent } from './empty_state-visual/empty-state-visual.component';

@Component({
    selector: 'empty-state',
    standalone: true,
    imports: [FlexLayoutModule, EmptyStateVisualComponent],
    template: `
        <div fxLayout="column" fxLayoutAlign="center center">
            <empty-state-visual [visualSource]="visualSource"></empty-state-visual>
            <div class="p-empty-state">
                <div class="p-headline-5 p-tpgr-medium p-empty-state-headline">{{ text }}</div>
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./empty-state.component.scss'],
    providers: []
})
export class EmptyStateComponent {
    @Input() public visualSource?: EmptyStateVisualSource;
    @Input() public text?: string;
}
